export default {  
	add(){
		return "/google/form"
	},
	get(){
		return "/google/get"
	},    
}
